import React, {Component} from 'react';
import styles from './styles.css';
import {observer, inject} from 'mobx-react';
import classnames from 'classnames';
import DatePicker from 'react-toolbox/lib/date_picker';
import AutoComplete from 'react-toolbox/lib/autocomplete';
import Navigation from 'react-toolbox/lib/navigation';
import {List} from 'react-toolbox/lib/list';
import Dropdown from 'react-toolbox/lib/dropdown';
import m from 'moment';
import {locale_et} from 'lib/locale';
import Store from './BeeperStore';
import routes from 'routes';

import ExpandableListItem from 'components/ExpandableListItem/ExpandableListItem';
import DayView from './Components/DayView';
import DayGraphView from './Components/DayGraphView';
import MultiPersonView from './Components/MultiPersonView';
import SinglePersonView from './Components/SinglePersonView';
import EditEventView from './Components/EditEventView';
import Checkbox from "react-toolbox/lib/checkbox";

@inject("view") @observer
export default class Beeper extends Component {
  store = null;

  constructor() {
    super();
    this.store= new Store(routes.Lakrito[0]);
  }

  componentWillMount() {
    this.store.startListeners();
  }

  componentWillUnmount() {
    this.store.stopListeners();
  }

  handlePersonChange = (personId) => {
    if (personId === 'all') {
      this.store.setSelectedPerson({id: 'all'})
    } else {
      this.store.setSelectedPerson(this.store.people.get(personId));
    }
  };

  handleAddNewEvent = () => {
    this.store.setEditableEvent({
      personId: (this.store.selectedPerson && this.store.selectedPerson.id) || null,
      event: null,
      time: new Date().getTime()
    });
    this.store.toggleEditing();
  };

  renderData = () => {
    const store = this.store;

    // don't render anything if some of the data is missing
    if (!store.startDate || !store.endDate || !store.selectedPerson) return <div>Please fill the inputs</div>;

    // render single day view - is this needed?
    // if (m(store.startDate).isSame(m(store.endDate), 'day')) return <DayGraphView store={store}/>;

    // render multi person view
    if (store.selectedPerson.id === 'all') return <MultiPersonView persons={store.activePersons} store={store}/>;

    // render single person view
    if (store.selectedPerson) {
      store.selectedPerson.setOpen(true);
      return <SinglePersonView person={store.selectedPerson} store={store}/>;
    }

    return null;
  };

  render() {
    const store = this.store;
    const {view} = this.props;

    const actions = [
      { label: 'Täna', onClick: () => store.setDates(m().startOf('day'), m().endOf('day'))},
      { label: 'Eile', onClick: () => store.setDates(m().subtract(1, 'day').startOf('day'), m().subtract(1, 'day').endOf('day'))},
      { label: 'See Kuu', onClick: () => store.setDates(m().startOf('month'), m().endOf('day'))},
      { label: 'Eelmine Kuu', onClick: () => store.setDates(m().subtract(1, 'month').startOf('month'), m().subtract(1, 'month').endOf('month'))}
    ];

    if (view.userHasGroup(store.routeInfo.edit)) actions.push({ label: 'Lisa Sündmus', onClick: () => this.handleAddNewEvent()});

    return (
      <div className={styles.beeper}>
        <Navigation type="horizontal" actions={actions} />
        <div>
          <Dropdown
            auto
            allowBlank={false}
            source={store.peopleList}
            onChange={this.handlePersonChange}
            value={store.selectedPerson && store.selectedPerson.id}
          />
          <DatePicker
            label="algus"
            value={store.startDate}
            autoOk
            locale={locale_et}
            maxDate={new Date()}
            onChange={(date) => store.setStartDate(m(date).startOf('day'))}
            inputFormat={value => `${m(value).format('LL')}`}
          />
          <DatePicker
            label="lõpp"
            value={store.endDate}
            autoOk
            locale={locale_et}
            maxDate={new Date()}
            onChange={(date) => store.setEndDate(m(date).endOf('day'))}
            inputFormat={value => `${m(value).format('LL')}`}
          />
        </div>

        <List>
          {this.renderData()}
        </List>

        <EditEventView
          store={store}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Beeper/Beeper.js